import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { IconButton, Badge, Tooltip, Popover } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import NotificationsIcon from '@mui/icons-material/Notifications';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { useNotificaciones } from '../../features/notificaciones/useNotificaciones';
import NotificacionesPanel from '../../features/notificaciones/NotificacionesPanel';
import './Header.css';

function Header({ drawerOpen, onMenuClick }) {
  const navigate = useNavigate();
  const [profileOpen, setProfileOpen] = useState(false);
  const profileRef = useRef(null);
  const { noLeidas, count, marcar, marcarTodas } = useNotificaciones();
  const [notifAnchor, setNotifAnchor] = useState(null);

  useEffect(() => {
    function handleClickOutside(e) {
      if (profileRef.current && !profileRef.current.contains(e.target)) {
        setProfileOpen(false);
      }
    }

    function handleEscape(e) {
      if (e.key === 'Escape') {
        setProfileOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEscape);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
    };
  }, []);

  function handleVerPerfil() {
    setProfileOpen(false);
    navigate('/perfil');
  }

  return (
    <header className="header">
      <button className="header__menu-btn" onClick={onMenuClick} aria-label={drawerOpen ? 'Cerrar menú' : 'Abrir menú'}>
        {drawerOpen ? <CloseIcon /> : <MenuIcon />}
      </button>
      <div className="header__brand__container">
        <div className="header__brand">SweetMedical</div>
      </div>

      <div className="header__icons">
        <Tooltip title={count > 0 ? `${count} ${count === 1 ? 'notificación sin leer' : 'notificaciones sin leer'}` : 'Sin notificaciones nuevas'}>
          <IconButton
            onClick={(e) => setNotifAnchor(e.currentTarget)}
            aria-label="Notificaciones"
            color="inherit"
          >
            <Badge badgeContent={count} color="error">
              <NotificationsIcon className="header__icon" />
            </Badge>
          </IconButton>
        </Tooltip>
        <Popover
          open={Boolean(notifAnchor)}
          anchorEl={notifAnchor}
          onClose={() => setNotifAnchor(null)}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <NotificacionesPanel notificaciones={noLeidas} onItemClick={marcar} onMarcarTodas={marcarTodas} />
        </Popover>
        <div className="header__profile" ref={profileRef}>
          <button
            type="button"
            className="header__profile-btn"
            onClick={() => setProfileOpen(prev => !prev)}
            aria-label="Menú de perfil"
            aria-expanded={profileOpen}
            aria-haspopup="menu"
          >
            <AccountCircleIcon className="header__icon" />
          </button>
          {profileOpen && (
            <div className="header__dropdown" role="menu">
              <button
                type="button"
                className="header__dropdown-item"
                role="menuitem"
                onClick={handleVerPerfil}
              >
                Ver perfil
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}

export default Header;
